<div class="registered-work-compliance-details">
  <h4 class="details-title">Tiempo registrado en productos</h4>

  @if (companyProductSummaries().length === 0) {
    <p class="no-data">No hay productos con horas registradas</p>
  } @else {
    <div class="categories-list">
      @for (company_product of companyProductSummaries(); track company_product.name) {
        <div class="category-item">
          <div class="category-header">
            <span class="category-name">{{ company_product.name }}</span>
            <span class="category-hours">
              {{ company_product.done_hours | number: '1.1-1' }}h / {{ company_product.expected_hours | number: '1.1-1' }}h
            </span>
          </div>

          <div class="progress-bar-container">
            <div class="progress-bar-track">
              <div class="progress-bar-fill" [style.width.%]="company_product.percentage"></div>
            </div>
            <div class="progress-bar-labels">
              <span class="value">{{ company_product.percentage | number: '1.0-0' }}%</span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (weeks().length > 0) {
    <button mat-stroked-button class="weeks-button" (click)="openWeeksDialog()">
      <mat-icon>visibility</mat-icon>
      Ver detalle completo por semanas
    </button>
  }
</div>
